// A step with no screen of its own — `auto`, `action`, `fetch_url`, `load`,
// `save`, `handoff` — is only ever SHOWN when it stopped: an operation failed,
// a save was refused, a record was not found. The problems are listed by the
// shell (with "Go to step" where a field is to blame); this offers the way on:
// try again, or Back.

import { Loader2, RotateCcw } from 'lucide-react'
import { text } from '../model'
import { button, muted } from '../styles'
import type { StepProps } from './common'

export default function AutoStep({ ctl, handheld, retryLabel, note }: StepProps & {
  retryLabel?: string
  note?: string
}) {
  const { step, scope, busy } = ctl
  if (!step || !scope) return null
  if (busy) {
    return (
      <div style={{ ...muted, display: 'flex', alignItems: 'center', gap: 8 }}>
        <Loader2 size={16} className="spin" /> {busy}
      </div>
    )
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={muted}>{note || (step.help ? text(step.help, scope) : 'This step could not finish.')}</div>
      <div>
        <button type="button" style={button(handheld, true)} onClick={() => void ctl.retry()} data-tw-action="retry">
          <RotateCcw size={16} /> {retryLabel || 'Try again'}
        </button>
      </div>
    </div>
  )
}
